const footerLogos = {
  CYMSA: 'CYMSA',
  ARCOS: 'ARCOS',
  AGOTE: 'AGOTE',
  SEGUROS: 'SEGUROS',
  SAN_LUCAS: 'SLM',
  MATERNIDAD: 'SLP',
  OLIVOS: 'OLIVOS',
  ZABALA: 'ZABALA',
  ECO: 'ECO',
  BLUE: 'BLUE',
  SALTA: 'SALTA',
  FUNDATION: 'FUNDATION',
  LAUNDRY: 'LAUNDRY',
  CELLS: 'CELLS',
  ALTOS_DE_SALTA: 'ALTOS_DE_SALTA',
  ICBA: 'ICBA',
  LAS_LOMAS: 'LAS_LOMAS',
};

export const logoColumns = {
  1: [
    {
      id: footerLogos.CYMSA,
      logoBnW: `${process.env.PUBLIC_URL}/images/footer/slider/bnw/_cymsa.svg`,
      logoColor: `${process.env.PUBLIC_URL}/images/footer/slider/color/cymsa.svg`,
      alt: 'CYMSA',
      url: 'https://www.cymsa.com.ar/',
    },
    {
      id: footerLogos.ICBA,
      logoBnW: `${process.env.PUBLIC_URL}/images/footer/slider/bnw/ICBA.svg`,
      logoColor: `${process.env.PUBLIC_URL}/images/footer/slider/color/ICBA.svg`,
      width: 140,
      height: 70,
      alt: 'Instituto Cardiovascular',
      url: 'https://www.icba.com.ar/home',
    },
    {
      id: footerLogos.SAN_LUCAS,
      logoBnW: `${process.env.PUBLIC_URL}/images/footer/slider/bnw/_sanlucasmujer.svg`,
      logoColor: `${process.env.PUBLIC_URL}/images/footer/slider/color/sanlucasmujer.svg`,
      alt: 'San Lucas Mujeres',
      url: 'https://www.sanlucasmujer.com.ar/',
    },
    {
      id: footerLogos.ECO,
      logoBnW: `${process.env.PUBLIC_URL}/images/footer/slider/bnw/_ecco.svg`,
      logoColor: `${process.env.PUBLIC_URL}/images/footer/slider/color/ecco.svg`,
      alt: 'ECCO',
      url: 'https://www.ecco.com.ar/',
    },
  ],
  2: [
    {
      id: footerLogos.ARCOS,
      logoBnW: `${process.env.PUBLIC_URL}/images/footer/slider/bnw/_sanatoriolosarcos.svg`,
      logoColor: `${process.env.PUBLIC_URL}/images/footer/slider/color/sanatoriolosarcos.svg`,
      alt: 'Sanatorio Los Arcos',
      url: 'https://www.sanatoriolosarcos.com.ar/',
    },
    {
      id: footerLogos.LAS_LOMAS,
      logoBnW: `${process.env.PUBLIC_URL}/images/footer/slider/bnw/LAS-LOMAS.svg`,
      logoColor: `${process.env.PUBLIC_URL}/images/footer/slider/color/LAS-LOMAS.svg`,
      width: 130,
      height: 70,
      alt: 'Sanatorio Las Lomas',
      url: 'https://laslomas.com.ar/',
    },
    {
      id: footerLogos.MATERNIDAD,
      logoBnW: `${process.env.PUBLIC_URL}/images/footer/slider/bnw/_sanlucaspediatrica.svg`,
      logoColor: `${process.env.PUBLIC_URL}/images/footer/slider/color/sanlucaspediatrico.svg`,
      alt: 'San Lucas Pediátrica',
      url: 'https://www.sanlucaspediatrica.com.ar/',
    },
    {
      id: footerLogos.LAUNDRY,
      logoBnW: `${process.env.PUBLIC_URL}/images/footer/slider/bnw/_smglandry.svg`,
      logoColor: `${process.env.PUBLIC_URL}/images/footer/slider/color/smglandry.svg`,
      alt: 'Smg Landry',
      url: 'https://www.smglandry.com/',
    },
  ],
  3: [
    {
      id: footerLogos.AGOTE,
      logoBnW: `${process.env.PUBLIC_URL}/images/footer/slider/bnw/_sanatorioagote.svg`,
      logoColor: `${process.env.PUBLIC_URL}/images/footer/slider/color/sanatorioagote.svg`,
      alt: 'Sanatorio Agote',
      url: 'https://www.sanatorioagote.com.ar/',
    },
    {
      id: footerLogos.OLIVOS,
      logoBnW: `${process.env.PUBLIC_URL}/images/footer/slider/bnw/_clinicaolivos.svg`,
      logoColor: `${process.env.PUBLIC_URL}/images/footer/slider/color/clinicaolivos.svg`,
      alt: 'Clinica Olivos',
      url: 'https://www.clinicaolivos.com.ar/',
    },
    {
      id: footerLogos.ZABALA,
      logoBnW: `${process.env.PUBLIC_URL}/images/footer/slider/bnw/_clinicazabala.svg`,
      logoColor: `${process.env.PUBLIC_URL}/images/footer/slider/color/clinicazabala.svg`,
      alt: 'Clinica Zabala',
      url: 'https://www.clinicazabala.com.ar/',
    },
    {
      id: footerLogos.SALTA,
      logoBnW: `${process.env.PUBLIC_URL}/images/footer/slider/bnw/_institutosalta.svg`,
      logoColor: `${process.env.PUBLIC_URL}/images/footer/slider/color/institutosalta.svg`,
      alt: 'Instituto Vida Salta',
      url: 'http://www.institutovida.com.ar/',
    },
  ],
  4: [
    {
      id: footerLogos.SEGUROS,
      logoBnW: `${process.env.PUBLIC_URL}/images/footer/slider/bnw/_swissmedicalseguros.svg`,
      logoColor: `${process.env.PUBLIC_URL}/images/footer/slider/color/swissmedicalseguros.svg`,
      alt: 'Swiss Medical Seguros',
      url: 'https://seguros.swissmedical.com.ar/',
    },
    {
      id: footerLogos.CELLS,
      logoBnW: `${process.env.PUBLIC_URL}/images/footer/slider/bnw/_swissmedicalcells.svg`,
      logoColor: `${process.env.PUBLIC_URL}/images/footer/slider/color/swissmedicalcells.svg`,
      alt: 'Swiss Medical Cells',
      url: 'https://www.swissmedicalcells.com/',
    },
    {
      id: footerLogos.FUNDATION,
      logoBnW: `${process.env.PUBLIC_URL}/images/footer/slider/bnw/_fundacionswissmedical.svg`,
      logoColor: `${process.env.PUBLIC_URL}/images/footer/slider/color/fundacionswissmedical.svg`,
      alt: 'Fundación Swiss Medical',
      url: 'https://www.swissmedical.com.ar/smgnewsite/smglife/',
    },
    {
      id: footerLogos.BLUE,
      logoBnW: `${process.env.PUBLIC_URL}/images/footer/slider/bnw/_bcbs.svg`,
      logoColor: `${process.env.PUBLIC_URL}/images/footer/slider/color/bcbs.svg`,
      alt: 'Blue Cross & Blue Shield',
      url: 'http://www.bcbs.com.uy/',
    },
  ],
  5: [
    {
      id: footerLogos.ALTOS_DE_SALTA,
      logoBnW: `${process.env.PUBLIC_URL}/images/footer/slider/bnw/AltosDeSalta.svg`,
      logoColor: `${process.env.PUBLIC_URL}/images/footer/slider/color/AltosDeSalta.svg`,
      width: 140,
      height: 70,
      alt: 'Sanatorio Altos de Salta',
      url: 'https://www.swissmedical.com.ar/clinewsite/altos_salta/',
    },
  ],
};
